import useStorage from './useStorage';
export { default as useAxios } from 'axios-hooks';
export { default as useTheme } from './useTheme';
export { default as useAPI } from './useAPI';
export { default as useBrowserBackButton } from './useBrowserBackButton';
export { default as useCMS } from './useCMS';
export { default as useModal } from './useModal';
export { default as usePromise } from './usePromise';
export { default as useScrollDirection, Direction } from './useScrollDirection';
export { default as useToast } from './useToast';
export { default as useStorage } from './useStorage';
export { default as usePortal } from './usePortal';
export { default as useOutSideClick } from './useOutSideClick';
export { default as useHover } from './useHover';
export { default as useDebounce } from './useDebounce';
export var useLocalStorage = useStorage('localStorage');
export var useSessionStorage = useStorage('sessionStorage');
//# sourceMappingURL=index.js.map